import { StatedutyCalculator } from "../common/stateduty/calc";

class SdsCalculator extends StatedutyCalculator {
    code() { return "sds"; }
    type() { return "CalcStateDutySoj"; }
    initialize() {
        this.calcName = "Gosp_Soj";
        super.initialize();

        this.addInputField("#calcOpt1Block .field-div input", "opt1Input", {
            type: "money", 
            options: {keyup: true },
        });

        this.addInputField("#calcOpt3Block .field-div input", "opt3Input", {
            type: "money", 
            options: {keyup: true },
        });

        this.addInputField(".checkboxrow-opt-3", "optionThird");

        const sendStatisticByCheckbox = () => {
            let goalParams = {
                message: this.getHash(), 
                prefix: ""
            };

            if (this.getHash() == "Imusch_1") {
                goalParams.args = { Dobav_Neimusch: this.optionFirst, Dobav_Rastorg_braka: this.optionSecond };
            } else if (this.getHash() == "Neimusch_1") {
                goalParams.args = { Dobav_Imusch_1: this.optionFirst }
            } else if (this.getHash() == "Neimusch_2") {
                goalParams.args = { Dobav_Imusch_2: this.optionFirst }
            }
            
            this.sendStatisticMessage(goalParams);
        };

        $("#calcOpt1Checkbox, #calcOpt2Checkbox").change(sendStatisticByCheckbox);
        $(window).on("hashchange", sendStatisticByCheckbox);

        this.loadDescription();
        this.openCalcByHash();
        this.autoSubmit(null, true);
    }

    render() {
        super.render();
        $(".smart-link").each(function() {
            tools.initSmartLink(this);
        })
    }

    generateExportObject() {
        const result = super.generateExportObject();
        result.manual = {};
        result.render.bottomNote = this.bottomNote;
        result.render.tabHeaderOpt3 = $('#calcOpt3Block .duty-block-tabs .active-tab')?.text() || "";
        result.render.opt3Comment = $("#dutyValOpt3Comment p:visible").toArray()
            .map((comment) => tools.convertElemToTextWithLinksForExport(comment))
            .join("||");
        if (result.parse.dutyValInput == null)
            result.parse.dutyValInput = 0;
        if (result.parse.opt1Input == null)
            result.parse.opt1Input = 0;
        if (["Neimusch_1", "Neimusch_2"].indexOf(this.getHash()) != -1)
            result.render.tabHeaderOpt1 = "";
        result.manual.altNaming1 = this.altNaming1;
        result.manual.altNaming2 = this.altNaming2;
        return result;
    }

    calculateDuty(sum) {
        let comment = 'при цене иска ';
        let formula1 = '';
        let formula2 = '';
        let formula3 = '';
        let duty = 0;
        if (sum <= 20000) {
            if (sum < 10000) {
                duty = 400;
                formula1 = `${tools.getLocaleSumInRubbles(duty)}, т.к. ${tools.getLocaleSum(sum)} × 4% = ${tools.getLocaleSumInRubbles(sum * 0.04)} < ${tools.getLocaleSumInRubbles(duty)}`;
            } else {
                duty = sum * 0.04;
                formula1 = `${tools.getLocaleSum(sum)} × 4% = ${tools.getLocaleSumInRubbles(duty)}`;
            }
            comment += 'до 20&nbsp;000 рублей госпошлина составляет 4% цены, но не менее 400 рублей';
        } else if (sum <= 100000) {
            duty = (sum - 20000) * 0.03 + 800;
            formula1 = `${tools.getLocaleSum(800)} + 3% × (${tools.getLocaleSum(sum)} − ${tools.getLocaleSum(20000)}) = ${tools.getLocaleSum(800)} + ${tools.getLocaleSum((sum - 20000) * 0.03)} = ${tools.getLocaleSumInRubbles(duty)}`;
            comment += 'от 20&nbsp;001 рубля до 100&nbsp;000 рублей госпошлина составляет 800 рублей плюс 3% суммы, превышающей 20&nbsp;000 рублей';
        } else if (sum <= 200000) {
            duty = (sum - 100000) * 0.02 + 3200;
            formula1 = `${tools.getLocaleSum(3200)} + 2% × (${tools.getLocaleSum(sum)} − ${tools.getLocaleSum(100000)}) = ${tools.getLocaleSum(3200)} + ${tools.getLocaleSum((sum  - 100000) * 0.02)} = ${tools.getLocaleSumInRubbles(duty)}`;
            comment += 'от 100&nbsp;001 рубля до 200&nbsp;000 рублей госпошлина составляет 3 200 рублей плюс 2% суммы, превышающей 100&nbsp;000 рублей';
        } else if (sum <= 1000000) {
            duty = (sum - 200000) * 0.01 + 5200;
            formula1 = `${tools.getLocaleSum(5200)} + 1% × (${tools.getLocaleSum(sum)} − ${tools.getLocaleSum(200000)}) = ${tools.getLocaleSum(5200)} + ${tools.getLocaleSum((sum - 200000) * 0.01)} = ${tools.getLocaleSumInRubbles(duty)}`;
            comment += 'от 200&nbsp;001 рубля до 1&nbsp;000&nbsp;000 рублей госпошлина составляет 5 200 рублей плюс 1% суммы, превышающей 200&nbsp;000 рублей';
        } else {
            const dutyVal = (sum - 1000000) * 0.005 + 13200;
            duty = Math.min(60000, dutyVal);
            formula1 = `${tools.getLocaleSum(13200)} + 0,5% × (${tools.getLocaleSum(sum)} − ${tools.getLocaleSum(1000000)}) = ${tools.getLocaleSum(13200)} + ${tools.getLocaleSum((sum - 1000000) * 0.005)} = ${tools.getLocaleSumInRubbles(dutyVal)}`;
            if (dutyVal > 60000) {
                formula2 = `так как ${tools.getLocaleSumInRubbles(dutyVal)} > ${tools.getLocaleSumInRubbles(60000)}, то госпошлина при подаче иска составляет ${tools.getLocaleSumInRubbles(60000)}`;
            }
            comment += 'свыше 1&nbsp;000&nbsp;000 рублей госпошлина составляет 13 200 рублей плюс 0.5% суммы, превышающей 1&nbsp;000&nbsp;000 рублей, но не более 60&nbsp;000 рублей';
        }

        if (this.checkHash('Sud_prikaz')) {
            const additionalFormula = `${tools.getLocaleSum(duty)} × 50% = ${tools.getLocaleSumInRubbles(duty/2)}`;
            duty /= 2;
            if (formula2) {
                formula3 = additionalFormula;
            } else {
                formula2 = additionalFormula;
            }
        }

        return {duty, comment, formula1, formula2, formula3};
    }

    calculateDutyImusch1Neimusch7_9(sum) {
        let comment = this.checkHash('Neimusch_7') 
        ? 'при цене иска ' 
        : (this.checkHash('Imusch_1|Sud_prikaz|Neimusch_12') ? 'по искам имущественного характера при цене иска ' : 'при цене иска ');
        let formula1 = '';
        let formula2 = '';
        let formula3 = '';
        let duty = 0;
        if (sum <= 100_000) {
            duty = 4_000;
            formula1 = `${tools.getLocaleSumInRubbles(duty)}`;
            comment += 'до 100&nbsp;000 рублей госпошлина составляет 4&nbsp;000 рублей';
        } else if (sum <= 300_000) {
            duty = (sum - 100_000) * 0.03 + 4_000;
            formula1 = `${tools.getLocaleSum(4_000)} + 3% × (${tools.getLocaleSum(sum)} − ${tools.getLocaleSum(100_000)}) = ${tools.getLocaleSum(4_000)} + ${tools.getLocaleSum((sum - 100_000) * 0.03)} = ${tools.getLocaleSumInRubbles(duty)}`;
            comment += 'от 100&nbsp;001 рубля до 300&nbsp;000 рублей госпошлина составляет 4&nbsp;000 рублей плюс 3% суммы, превышающей 100&nbsp;000 рублей';
        } else if (sum <= 500_000) {
            duty = (sum - 300_000) * 0.025 + 10_000;
            formula1 = `${tools.getLocaleSum(10_000)} + 2,5% × (${tools.getLocaleSum(sum)} − ${tools.getLocaleSum(300_000)}) = ${tools.getLocaleSum(10_000)} + ${tools.getLocaleSum((sum  - 300_000) * 0.025)} = ${tools.getLocaleSumInRubbles(duty)}`;
            comment += 'от 300&nbsp;001 рубля до 500&nbsp;000 рублей госпошлина составляет 10 000 рублей плюс 2,5% суммы, превышающей 300&nbsp;000 рублей';
        } else if (sum <= 1_000_000) {
            duty = (sum - 500_000) * 0.02 + 15_000;
            formula1 = `${tools.getLocaleSum(15_000)} + 2% × (${tools.getLocaleSum(sum)} − ${tools.getLocaleSum(500_000)}) = ${tools.getLocaleSum(15_000)} + ${tools.getLocaleSum((sum - 500_000) * 0.02)} = ${tools.getLocaleSumInRubbles(duty)}`;
            comment += 'от 500&nbsp;001 рубля до 1&nbsp;000&nbsp;000 рублей госпошлина составляет 15 000 рублей плюс 2% суммы, превышающей 500&nbsp;000 рублей';
        } else if (sum <= 3_000_000) {
            duty = (sum - 1_000_000) * 0.01 + 25_000;
            formula1 = `${tools.getLocaleSum(25_000)} + 1% × (${tools.getLocaleSum(sum)} − ${tools.getLocaleSum(1_000_000)}) = ${tools.getLocaleSum(25_000)} + ${tools.getLocaleSum((sum - 1_000_000) * 0.01)} = ${tools.getLocaleSumInRubbles(duty)}`;
            comment += 'от 1&nbsp;000&nbsp;001 рубля до 3&nbsp;000&nbsp;000 рублей госпошлина составляет 25 000 рублей плюс 1% суммы, превышающей 1&nbsp;000&nbsp;000 рублей';
        } else if (sum <= 8_000_000) {
            duty = (sum - 3_000_000) * 0.007 + 45_000;
            formula1 = `${tools.getLocaleSum(45_000)} + 0,7% × (${tools.getLocaleSum(sum)} − ${tools.getLocaleSum(3_000_000)}) = ${tools.getLocaleSum(45_000)} + ${tools.getLocaleSum((sum - 3_000_000) * 0.007)} = ${tools.getLocaleSumInRubbles(duty)}`;
            comment += 'от 3&nbsp;000&nbsp;001 рубля до 8&nbsp;000&nbsp;000 рублей госпошлина составляет 45 000 рублей плюс 0,7% суммы, превышающей 3&nbsp;000&nbsp;000 рублей';
        } else if (sum <= 24_000_000) {
            duty = (sum - 8_000_000) * 0.0035 + 80_000;
            formula1 = `${tools.getLocaleSum(80_000)} + 0,35% × (${tools.getLocaleSum(sum)} − ${tools.getLocaleSum(8_000_000)}) = ${tools.getLocaleSum(80_000)} + ${tools.getLocaleSum((sum - 8_000_000) * 0.0035)} = ${tools.getLocaleSumInRubbles(duty)}`;
            comment += 'от 8&nbsp;000&nbsp;001 рубля до 24&nbsp;000&nbsp;000 рублей госпошлина составляет 80 000 рублей плюс 0,35% суммы, превышающей 8&nbsp;000&nbsp;000 рублей';
        } else if (sum <= 50_000_000) {
            duty = (sum - 24_000_000) * 0.003 + 136_000;
            formula1 = `${tools.getLocaleSum(136_000)} + 0,3% × (${tools.getLocaleSum(sum)} − ${tools.getLocaleSum(24_000_000)}) = ${tools.getLocaleSum(136_000)} + ${tools.getLocaleSum((sum - 24_000_000) * 0.003)} = ${tools.getLocaleSumInRubbles(duty)}`;
            comment += 'от 24&nbsp;000&nbsp;001 рубля до 50&nbsp;000&nbsp;000 рублей госпошлина составляет 136 000 рублей плюс 0,3% суммы, превышающей 24&nbsp;000&nbsp;000 рублей';
        } else if (sum <= 100_000_000) {
            duty = (sum - 50_000_000) * 0.002 + 214_000;
            formula1 = `${tools.getLocaleSum(214_000)} + 0,2% × (${tools.getLocaleSum(sum)} − ${tools.getLocaleSum(50_000_000)}) = ${tools.getLocaleSum(214_000)} + ${tools.getLocaleSum((sum - 50_000_000) * 0.002)} = ${tools.getLocaleSumInRubbles(duty)}`;
            comment += 'от 50&nbsp;000&nbsp;001 рубля до 100&nbsp;000&nbsp;000 рублей госпошлина составляет 214 000 рублей плюс 0,2% суммы, превышающей 50&nbsp;000&nbsp;000 рублей';
        } else {
            const dutyVal = (sum - 100_000_000) * 0.0015 + 314_000;
            duty = Math.min(900_000, dutyVal);
            formula1 = `${tools.getLocaleSum(314_000)} + 0,15% × (${tools.getLocaleSum(sum)} − ${tools.getLocaleSum(100_000_000)}) = ${tools.getLocaleSum(314_000)} + ${tools.getLocaleSum((sum - 100_000_000) * 0.0015)} = ${tools.getLocaleSumInRubbles(dutyVal)}`;
            if (dutyVal > 900_000) {
                formula2 = `так как ${tools.getLocaleSumInRubbles(dutyVal)} > ${tools.getLocaleSumInRubbles(900_000)}, то госпошлина при подаче иска составляет ${tools.getLocaleSumInRubbles(900_000)}`;
            }
            comment += 'свыше 100&nbsp;000&nbsp;000 рублей госпошлина составляет 314 000 рублей плюс 0.15% суммы, превышающей 100&nbsp;000&nbsp;000 рублей, но не более 900&nbsp;000 рублей';
        }

        if (this.checkHash('Neimusch_7')) {
            const additionalFormula = `${tools.getLocaleSum(duty)} × 30% = ${tools.getLocaleSumInRubbles(duty * 0.3)}`;
            duty *= 0.3;
            if (formula2) {
                formula3 = additionalFormula;
            } else {
                formula2 = additionalFormula;
            }
        } else if (this.checkHash('Sud_prikaz')) {
            const additionalFormula = `${tools.getLocaleSum(duty)} × 50% = ${tools.getLocaleSumInRubbles(duty/2)}`;
            duty /= 2;
            if (formula2) {
                formula3 = additionalFormula;
            } else {
                formula2 = additionalFormula;
            }
        }

        return {duty, comment, formula1, formula2, formula3};
    }

    calculateDutyImusch4(sum) {
        let comment = 'при цене иска ';
        let formula1 = '';
        let formula2 = '';
        let formula3 = '';
        let duty = 0;
        if (sum <= 1_000_000) {
            duty = 0;
            comment += '1 млн руб. и менее истцы освобождены от уплаты пошлины (<a href="#" class="smart-link" data-link="req=doc&base=LAW&n=482748&dst=59">п. 3 ст. 17</a> Закона N 2300-1; <a href="#" class="smart-link" data-link="req=doc&base=LAW&n=480811&dst=11645">пп. 4 п. 2</a>, <a href="#" class="smart-link" data-link="req=doc&base=LAW&n=480811&dst=11647">п. 3 ст. 333.36</a> НК РФ)';
        } else if (sum <= 3_000_000) {
            duty = (sum - 1_000_000) * 0.01 + 25_000;
            formula1 = `${tools.getLocaleSum(25_000)} + 1% × (${tools.getLocaleSum(sum)} − ${tools.getLocaleSum(1_000_000)}) = ${tools.getLocaleSum(25_000)} + ${tools.getLocaleSum((sum - 1_000_000) * 0.01)} = ${tools.getLocaleSumInRubbles(duty)}`;
            comment += 'от 1 000 001 рубля до 3 000 000 рублей госпошлина составляет 25 000 рублей плюс 1% суммы, превышающей 1 000 000 рублей<br/><a href="#" class="smart-link" data-link="req=doc&base=LAW&n=482896&dst=26562">пп. 1 п. 1 ст. 333.19 НК РФ</a>';
        } else if (sum <= 8_000_000) {
            duty = (sum - 3_000_000) * 0.007 + 45_000;
            formula1 = `${tools.getLocaleSum(45_000)} + 0,7% × (${tools.getLocaleSum(sum)} − ${tools.getLocaleSum(3_000_000)}) = ${tools.getLocaleSum(45_000)} + ${tools.getLocaleSum((sum - 3_000_000) * 0.007)} = ${tools.getLocaleSumInRubbles(duty)}`;
            comment += 'от 3 000 001 рубля до 8 000 000 рублей госпошлина составляет 45 000 рублей плюс 0,7% суммы, превышающей 3 000 000 рублей<br/><a href="#" class="smart-link" data-link="req=doc&base=LAW&n=482896&dst=26562">пп. 1 п. 1 ст. 333.19 НК РФ</a>';
        } else if (sum <= 24_000_000) {
            duty = (sum - 8_000_000) * 0.0035 + 80_000;
            formula1 = `${tools.getLocaleSum(80_000)} + 0,35% × (${tools.getLocaleSum(sum)} − ${tools.getLocaleSum(8_000_000)}) = ${tools.getLocaleSum(80_000)} + ${tools.getLocaleSum((sum - 8_000_000) * 0.0035)} = ${tools.getLocaleSumInRubbles(duty)}`;
            comment += 'от 8 000 001 рубля до 24 000 000 рублей госпошлина составляет 80 000 рублей плюс 0,35% суммы, превышающей 8 000 000 рублей<br/><a href="#" class="smart-link" data-link="req=doc&base=LAW&n=482896&dst=26562">пп. 1 п. 1 ст. 333.19 НК РФ</a>';
        } else if (sum <= 50_000_000) {
            duty = (sum - 24_000_000) * 0.003 + 136_000;
            formula1 = `${tools.getLocaleSum(136_000)} + 0,3% × (${tools.getLocaleSum(sum)} − ${tools.getLocaleSum(24_000_000)}) = ${tools.getLocaleSum(136_000)} + ${tools.getLocaleSum((sum - 24_000_000) * 0.003)} = ${tools.getLocaleSumInRubbles(duty)}`;
            comment += 'от 24 000 001 рубля до 50 000 000 рублей госпошлина составляет 136 000 рублей плюс 0,3% суммы, превышающей 24 000 000 рублей<br/><a href="#" class="smart-link" data-link="req=doc&base=LAW&n=482896&dst=26562">пп. 1 п. 1 ст. 333.19 НК РФ</a>';
        } else if (sum <= 100_000_000) {
            duty = (sum - 50_000_000) * 0.002 + 214_000;
            formula1 = `${tools.getLocaleSum(214_000)} + 0,2% × (${tools.getLocaleSum(sum)} − ${tools.getLocaleSum(50_000_000)}) = ${tools.getLocaleSum(214_000)} + ${tools.getLocaleSum((sum - 50_000_000) * 0.002)} = ${tools.getLocaleSumInRubbles(duty)}`;
            comment += 'от 50 000 001 рубля до 100 000 000 рублей госпошлина составляет 214 000 рублей плюс 0,2% суммы, превышающей 50 000 000 рублей<br/><a href="#" class="smart-link" data-link="req=doc&base=LAW&n=482896&dst=26562">пп. 1 п. 1 ст. 333.19 НК РФ</a>';
        } else {
            duty = (sum - 100_000_000) * 0.0015 + 314_000;
            formula1 = `${tools.getLocaleSum(314_000)} + 0,15% × (${tools.getLocaleSum(sum)} − ${tools.getLocaleSum(100_000_000)}) = ${tools.getLocaleSum(314_000)} + ${tools.getLocaleSum((sum - 100_000_000) * 0.0015)} = ${tools.getLocaleSumInRubbles(duty)}`;
            comment += 'свыше 100 000 000 рублей госпошлина составляет 314 000 рублей плюс 0,15 процента суммы, превышающей 100 000 000 рублей, но не более 900 000 рублей<br/><a href="#" class="smart-link" data-link="req=doc&base=LAW&n=482896&dst=26562">пп. 1 п. 1 ст. 333.19 НК РФ</a>';
            if (duty > 900_000) {
                formula2 = `так как ${tools.getLocaleSumInRubbles(duty)} > 900 000,00 ₽, то госпошлина при подаче иска имущественного характера составляет 900 000,00 ₽`;
                duty = 900_000;
            }
        }

        if (duty > 25_000) {
            const lastComment = `${tools.getLocaleSum(duty)} - ${tools.getLocaleSum(25_000)} = ${tools.getLocaleSumInRubbles(duty - 25_000)}`;
            if (formula2) {
                formula3 = lastComment;
            } else {
                formula2 = lastComment;
            }
            duty -= 25_000;
        }

        return {duty, comment, formula1, formula2, formula3};
    }

    calculate() {
        this.bottomNote = false;
        const hashValue = this.getHash();
        let mainDutyResult = null;
        const neimuschMB = $(".results-div.type-neimusch .main-block");
        if (neimuschMB.length)
            neimuschMB.removeClass("raised");
        switch(hashValue) {
            case 'Neimusch_1':
            case 'Neimusch_2':
                neimuschMB.addClass("raised");
            case 'Neimusch_12':
                mainDutyResult = {duty: $(".duty-main-val.active-item").data("value")}
                this.bottomNote = true;
                break;
            case 'Imusch_1':
            case 'Neimusch_7':
            case 'Neimusch_9':
            case 'Sud_prikaz':
                mainDutyResult = this.calculateDutyImusch1Neimusch7_9(this.dutyValInput)
                break;    
            case 'Imusch_4':
                mainDutyResult = this.calculateDutyImusch4(this.dutyValInput)
                break;       
            default:
                mainDutyResult = this.calculateDuty(this.dutyValInput)
                break;
        }

        this.mainBlockDutyVal = mainDutyResult.duty;
        this.mainBlockComment = mainDutyResult.comment;
        this.totalDutyVal = this.mainBlockDutyVal;
        this.mainFormula1 = mainDutyResult.formula1;
        this.mainFormula2 = mainDutyResult.formula2;
        this.mainFormula3 = mainDutyResult.formula3;

        let opt1DutyResult = this.calculateDutyImusch1Neimusch7_9(this.opt1Input);
        this.opt1BlockDutyVal = opt1DutyResult.duty;
        this.opt1BlockComment = opt1DutyResult.comment;
        this.firstFormula1 = opt1DutyResult.formula1;
        this.firstFormula2 = opt1DutyResult.formula2;
        this.firstFormula3 = opt1DutyResult.formula3;

        if (this.optionFirst) {
            if (hashValue === 'Neimusch_1' || hashValue === 'Neimusch_2') {
                this.totalDutyVal += this.opt1BlockDutyVal;
            } else {
                this.totalDutyVal += +($(".duty-val-opt1").data("value"));
            }
        }

        if (this.optionSecond) {
            this.totalDutyVal += +$(".duty-val-opt2").data("value");
        }

        if (this.optionThird) {
            if (hashValue === 'Neimusch_12') {
                let opt3DutyResult = this.calculateDutyImusch1Neimusch7_9(this.opt3Input);
                this.opt3BlockDutyVal = opt3DutyResult.duty;
                this.opt3BlockComment = opt3DutyResult.comment;
                this.thirdFormula1 = opt3DutyResult.formula1;
                this.thirdFormula2 = opt3DutyResult.formula2;
                this.thirdFormula3 = opt3DutyResult.formula3;

                this.totalDutyVal += opt3DutyResult.duty;
            } else {
                this.totalDutyVal += +$(".duty-val-opt3").data("value");
            }
        }

        this.altNaming1 = "";
        this.altNaming2 = "";
        if (this.checkHash("Neimusch_9")) {
            this.altNaming1 = "оспариваемая сумма";
            this.altNaming2 = "при оспариваемой сумме";
        }

        return true;
    }
}


$(function () {
    var calc = new SdsCalculator();
});
